import Filtration from "../../../components/Sortcomponents/Filtration";
import PatternListAdmin from "../../../screens/PatternListAdmin";
import style from "../styles/ListPattern.module.scss"

export default function ListPattern() {
    return (
        <div className={style.container}>
            <Filtration />
            <PatternListAdmin />
        </div>
    )
}